export const openBookIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
     fill="none">
    <path d="M0 6V17.529C0 17.529 4.621 17.357 10 20C15.379 17.357 20 17.529 20 17.529V6C20 6 14.546 6 10 8.471C5.454 6 0 6 0 6Z"
          fill="var(--zbp-svg-primary-color, black)"
    />
    <path d="M10 6C11.6569 6 13 4.65685 13 3C13 1.34315 11.6569 0 10 0C8.34315 0 7 1.34315 7 3C7 4.65685 8.34315 6 10 6Z"
          fill="var(--zbp-svg-primary-color, black)"
    />
</svg>
`;
